import React, { useState, useMemo, useEffect } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import useStore from '../../states/store';
import TabPanel from '../../components/TabPanel';
import useTargetContext from './context/useTargetContext';
import Filter from './components/Filter';
import Table from './components/Table';
import JusticationModal from './components/JusticationModal';
import { getTargetList, postUpdateStatus } from '../../api/targetMaintenance';

export default function TargetMaintenance() {
  const auth = useStore((state) => state.auth);
  const date = new Date();
  const monthsOptions = [
    { label: 'ALL', value: null },
    { label: 'January', value: '01' },
    { label: 'February', value: '02' },
    { label: 'March', value: '03' },
    { label: 'April', value: '04' },
    { label: 'May', value: '05' },
    { label: 'June', value: '06' },
    { label: 'July', value: '07' },
    { label: 'August', value: '08' },
    { label: 'September', value: '09' },
    { label: 'October', value: '10' },
    { label: 'November', value: '11' },
    { label: 'December', value: '12' },
  ];

  const yearOptions = [];
  /* eslint-disable no-plusplus */
  for (let i = 2010; i <= date.getFullYear(); i++) {
    yearOptions.push({ label: i.toString(), value: i.toString() });
  }

  const defaultFilter = {
    department: { label: 'ALL', value: null },
    manager_id: { label: 'ALL', value: null },
    rep_id: { label: 'ALL', value: null },
    md: { label: 'ALL', value: null },
    month: [monthsOptions[0]],
    year: { label: date.getFullYear().toString(), value: date.getFullYear().toString() },
  };

  const justificationDefaultForm = {
    is_copy_reason: 0,
    justification: '',
  };
  const [targetUpdate, setTargetUpdate] = useState({ row: '', status: '', isall: '' });
  const [justificationForm, setJustificationForm] = useState(justificationDefaultForm);
  const [activeTab, setActiveTab] = useState(0);
  const [filterForm, setFilterForm] = useState(defaultFilter);
  const [targetData, setTargetData] = useState([]);
  const [rowsSelected, setRowsSelected] = useState([]);
  const [loading, setLoading] = useState(false);
  const [justificationModal, setJustificationModal] = useState(false);
  const handleChangeActiveTab = (event, newValue) => {
    setActiveTab(newValue);
  };

  let approveStatusValue;
  if (activeTab === 0) {
    approveStatusValue = 5;
  } else if (activeTab === 1) {
    approveStatusValue = 1;
  } else if (activeTab === 2) {
    approveStatusValue = 2;
  }

  const searchTarget = async () => {
    try {
      let changeStatus;
      if (activeTab === 1) {
        changeStatus = [5];
      } else if (activeTab === 2) {
        changeStatus = [1];
      } else if (activeTab === 3) {
        changeStatus = [2];
      } else if (activeTab === 4) {
        changeStatus = [3, 4, 6];
      } else {
        changeStatus = [activeTab];
      }

      let changeManagerID;
      if (
        auth.level === 'Level 3' ||
        auth.level === 'Level 4' ||
        auth.level === 'admin' ||
        auth.designation === 'admin'
      ) {
        changeManagerID = filterForm?.manager_id?.value;
      } else {
        changeManagerID = auth.user_id;
      }

      setLoading(true);
      setTargetData([]);

      const months = filterForm?.month.map((row) =>
        row.value !== null ? parseFloat(row.value) : null,
      );

      const statusType = {
        department: filterForm?.department?.value,
        manager_id: changeManagerID,
        rep_id: filterForm?.rep_id?.value,
        md: filterForm?.md?.value,
        month: months.includes(null) ? [] : months,
        status: changeStatus,
      };
      const response = await getTargetList(statusType);
      const { code, data } = response.data;
      if (code === '200') {
        setTargetData(data);
      }
      setLoading(false);
    } catch (error) {
      toast.error(error.message);
    }
  };
  const clearTarget = () => {
    setFilterForm(defaultFilter);
    searchTarget();
  };

  const handleUpdateAll = (row, status, isall) => {
    const statusText = status === 5 ? 'approve' : 'reject';
    Swal.fire({
      icon: 'warning',
      title: `Are you sure you want to ${
        isall === true ? 'approve all selected' : statusText
      }  changes on the target frequency?`,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: '<small style="color:#fff"> Confirm </small>',
      cancelButtonText: '<small style="color:#fff"> Cancel </small>',
    }).then((response) => {
      if (response.isConfirmed) {
        toast.loading('in progress please kindly wait');

        const targetDetailsForm =
          isall === true
            ? {
                designation: auth.designation,
                ...justificationForm,
                data: rowsSelected?.map((item) => ({
                  id: item.id,
                  status_id: status,
                })),
              }
            : {
                designation: auth.designation,
                ...justificationForm,
                data: [{ id: row, status_id: status }],
              };
        try {
          postUpdateStatus(targetDetailsForm).then((res) => {
            const { code, message } = res.data;
            if (code === '200') {
              toast.dismiss();
              toast.success(message);
              searchTarget();
              toast.dismiss();
              setJustificationModal(false);
              setJustificationForm(justificationDefaultForm);
            }

            if (res.data.response.code === '500') {
              Swal.fire({
                title: 'Invalid Request',
                html: res.data.response.result.join('<br />'),
                icon: 'warning',
              });
            }
          });
        } catch (error) {
          toast.error(error.message);
        }
      }
    });
  };

  const handleJustification = (rowValue = null, statusValue = null, isallValue = null) => {
    if (isallValue === true) {
      if (rowsSelected.length <= 0) {
        toast.warning('No selected row(s)');
        return;
      }
    }
    setJustificationForm(justificationDefaultForm);
    setTargetUpdate({ ...targetUpdate, row: rowValue, status: statusValue, isall: isallValue });
    if (activeTab === 0) {
      setJustificationModal(true);
    }

    if (activeTab === 1 || activeTab === 2) {
      handleUpdateAll(rowValue, statusValue, isallValue);
    }
  };

  useEffect(() => {
    searchTarget();
  }, [activeTab]);
  return (
    <div style={{ position: 'relative' }}>
      <useTargetContext.Provider
        value={useMemo(
          () => ({
            auth,
            activeTab,
            targetData,
            setFilterForm,
            filterForm,
            monthsOptions,
            yearOptions,
            searchTarget,
            clearTarget,
            loading,
            handleUpdateAll,
            rowsSelected,
            setRowsSelected,
            handleJustification,
            justificationModal,
            justificationForm,
            justificationDefaultForm,
            setJustificationModal,
            setJustificationForm,
            targetUpdate,
            approveStatusValue,
          }),
          [
            filterForm,
            targetData,
            loading,
            rowsSelected,
            justificationForm,
            justificationModal,
            targetUpdate,
          ],
        )}
      >
        <Box sx={{ backgroundColor: '#fff', p: 1, boxShadow: 3 }}>
          <Filter />
        </Box>
        <Box padding={4}>
          <Box>
            <Box>
              <Grid container spacing={2}>
                <Grid xs={12} sm={12} md={12}>
                  <Box sx={{ backgroundColor: '#fff' }} mt={4}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                      <Tabs
                        value={activeTab}
                        onChange={handleChangeActiveTab}
                        aria-label='basic tabs example'
                      >
                        <Tab
                          label='For Manager Approval'
                          id='target-for-manager-approval'
                          aria-controls='target-for-manager-approval'
                        />
                        <Tab
                          label='For KASROM/RSM Approval'
                          id='target-for-kasrom-approval'
                          aria-controls='target-for-kasrom-approval'
                        />
                        <Tab
                          label='For Admin Approval'
                          id='target-for-admin-approval'
                          aria-controls='target-for-admin-approval'
                        />
                        <Tab
                          label='Approved'
                          id='target-approved'
                          aria-controls='target-approved'
                        />
                        <Tab
                          label='Rejected'
                          id='target-rejected'
                          aria-controls='target-rejected'
                        />
                      </Tabs>
                    </Box>
                    <TabPanel value={activeTab} index={activeTab}>
                      <Table />
                    </TabPanel>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
        <JusticationModal />
      </useTargetContext.Provider>
    </div>
  );
}
